/**
 * 海外「用户声音」：来自 2026-08 批次真实问卷回收（日语区 + 英语区受访者），原文照登、仅做长度裁剪。
 */
export const GLOBAL_TESTIMONIALS = [
  {
    author: {
      name: 'SZOU☆channel',
      role: 'AIコンテンツクリエイター',
      avatar: 'https://image01.cf.vidu.studio/vidu/media-asset/20260710-7db7e0050753437a9a8aa523d025380f-06a77dc7.webp',
    },
    text: '難しい操作を覚えることよりも、まず自分のアイデアを映像にして試せるので、AI動画を始めたばかりの人にも、もっと凝った作品を作りたいクリエイターにもおすすめしたいです！',
  },
  {
    author: {
      name: 'SHOWA風ドリア',
      role: '会社員',
      avatar: 'https://image01.cf.vidu.studio/vidu/media-asset/channels4_profile-taroRyu-56d1ee20.webp',
    },
    text: '音声付き且つプロンプト理解力が高いQ3をわずか6クレジット(5秒)で使えること。これのおかげで、試行回数を高めることで動画のクオリティがとてもあがりました。コスパが圧倒的に良いサービスがviduと考えています',
  },
  {
    author: {
      name: 'SOUTSU',
      role: 'AIクリエイター',
      avatar: 'https://image01.cf.vidu.studio/vidu/media-asset/SOUTSU-2025-04-05T181853-9677c3be.webp',
    },
    text: '私はアクション、コメディ、ドラマなど幅広いジャンルの作品を制作していますが、Viduはジャンルを問わずチャレンジしやすく、新しいアイデアを次々と試せる環境があります。単に動画を生成するだけでなく、「次はこんな作品も作ってみたい」と創作意欲が湧いてくることが、Viduならではの大きな魅力だと感じています。',
  },
  {
    author: {
      name: 'こうたろう🐸ケロキング',
      role: '会社員',
      avatar: 'https://image01.cf.vidu.studio/vidu/media-asset/IMG_9402-koutarou-kero-debcfef0.webp',
    },
    text: 'Viduで特に気に入っているのは、やはりアニメーションの表現力の高さです。細かい表情や、ニュアンスが伝わりやすく、アニメーションの質がとても高いと思います。Viduの一番の魅力はクリエイターの声をよく聞いてくれていることだと思います。意見を挙げると、極力すぐに反映してくれるなど、クリエイターの目線で物事を見てくれているなと感じています。自分のアニメをつくるきっかけになったのがViduです。おそらくViduがないと今のクリエイター活動はなかったと思います。',
  },
  {
    author: {
      name: "i'DEAR MUSIC",
      role: '作曲家・映像クリエイター',
      avatar: 'https://image01.cf.vidu.studio/vidu/media-asset/mygollow-4ec8e31a.webp',
    },
    text: 'ViduはUIがとても使いやすくて、直感的に操作できるところが好きです♡',
  },
  {
    author: {
      name: 'bell_bright',
      role: '会社員',
      avatar: 'https://image01.cf.vidu.studio/vidu/media-asset/bellbright_icon-04707111.webp',
    },
    text: '一番はセリフ回しだと思います。AIならではの棒読みがなく実際の声優がアテレコしたんじゃないかというクオリティが出せます。これだけで作品レベルが数段上がるようなきがします！',
  },
  {
    author: {
      name: 'きゅにお',
      role: '会社員',
      avatar: 'https://image01.cf.vidu.studio/vidu/media-asset/8d9d24cc-73ad-f9be8b1a.webp',
    },
    text: 'コミュニケーションのシーンがあるアニメーションを作りたいなら、特にViduをおすすめしたいです。',
  },
  {
    author: {
      name: 'Artemis Lechat',
      role: 'Data Analyst',
      avatar: 'https://image01.cf.vidu.studio/vidu/media-asset/ArtemisLechat-6fbc1963.webp',
    },
    text: '“Vidu brings animated characters to life in a way I haven’t seen anywhere else. The facial expressions, subtle movements, and nonverbal details give characters a level of emotion that makes storytelling feel natural. Character References also completely changed my workflow, saving me hours and helping me finally create stories I’d only imagined before.”',
  },
  {
    author: {
      name: '@_caradelata',
      role: 'Entrepreneur',
      avatar: 'https://image01.cf.vidu.studio/vidu/media-asset/@_caradelata-0f99bc8a.webp',
    },
    text: '“Creating with it just feels fun and frictionless. The motion is incredibly clean and consistent, with smooth, natural movement that keeps characters feeling like themselves. Instead of spending hours fighting prompts or rerolling generations, I can focus on storytelling, humor, and character dynamics. The first time it nailed the exact movement, chaos, and timing I had in my head, I knew I’d be using it every day.”',
  },
  {
    author: {
      name: 'schmede_ai',
      role: 'AI Configuration Specialist',
      avatar: 'https://image01.cf.vidu.studio/vidu/media-asset/schmede_ai-ca3194aa.webp',
    },
    text: '“There’s always something new to discover with Vidu. The motion feels fast, physical, and full of impact, especially in action sequences. It’s also changed how I work—I can now rely on it to fill the gaps between keyframes and references, turning hours of work into minutes.”',
  },
  {
    author: {
      name: 'Alper',
      role: 'Student',
      avatar: 'https://image01.cf.vidu.studio/vidu/media-asset/Alper-e80adea2.webp',
    },
    text: '“Off-Peak Mode is one of my favorite features—it gives me more room to experiment. The anime generation is also incredibly good, especially for recreating ’80s and ’90s styles or turning realistic characters into anime. Vidu CLI has made my workflow much faster, and Reference to Video was a game changer for the selfie POV videos I wanted to create.”',
  },
  {
    author: {
      name: 'GrimSmile',
      role: 'Retired',
      avatar: 'https://image01.cf.vidu.studio/vidu/media-asset/GrimSmile-36920787.webp',
    },
    text: '“Two years ago, Vidu was the only company that replied when I reached out, and that was enough to make me give it a try. It’s since become my home for AI-generated content. What keeps me here is the constant discovery—finding new workflows and new ways to create with the models.”',
  },
  {
    author: {
      name: 'wuxiarocks',
      role: 'Writer',
      avatar: 'https://image01.cf.vidu.studio/vidu/media-asset/wuxiarocks-fbc1839b.webp',
    },
    text: '“Vidu has completely changed the way I create. It’s fast, affordable, and gives me the flexibility to move between image and video seamlessly. Features like Reference to Video and Storyboard let me turn the ideas in my head into the stories I actually want to tell.”',
  },
];

/**
 * 国内「用户声音」：问卷尚未回收，先留空。
 * 有数据后按 GLOBAL_TESTIMONIALS 同结构补齐即可，无需改下面的渲染分支。
 */
export const CHINA_TESTIMONIALS = [
  {
    author: {
      name: '冰皓',
      role: '多参宗宗主',
      avatar: 'https://image01-aliyun.vidu.zone/vidu/media-asset/binghao-63822a83.webp',
    },
    text: '创立多参宗，和成千上万Vidu玩家从0到1，把AI视频玩出了花。这里有教程、有比赛、有战友，更有让创作者被看见的舞台。Vidu陪我们走的这条路，不只是做。视频，是让每个人都能用AI表达自己。',
  },
  {
    author: {
      name: 'Mashiro',
      role: 'ACGN爱好者',
      avatar: 'https://image01.vidu.zone/vidu/media-asset/userImageChina3-97972b0d.webp',
    },
    text: '我从小就想成为一名动画师。但要将我脑海中的创意转。化为动画，需要很高的技能。然而，Vidu的模型在动画。方面比市场上大多数其他AI产品更为出色，能够让我实现梦想!它的运作速度非常快，使用起来也很简单!',
  },
  {
    author: {
      name: '周立国',
      role: 'AIGC导演',
      avatar: 'https://image01-aliyun.vidu.zone/vidu/media-asset/zhouliguo-b4d39dc8.webp',
    },
    text: '我对Vidu的印象是:这是一家技术实力很突出的“小而强”公司。虽然公司规模不大，但功能做得很有特点。特别是多主体参考生视频功能，明显改善了AI视频里的角色一致性问题，在角色表演、运镜和特效上都表现不错。',
  },
  {
    author: {
      name: '骆狮虎',
      role: 'AIGC同行者',
      avatar: 'https://image01-aliyun.vidu.zone/vidu/media-asset/luoshihu-88e2d366.webp',
    },
    text: 'Vidu是老牌的视频大模型了，从Vidu出来到如今都是极具性价比的一款模型，无论是图生、首尾、多参考等功能也涵盖了多功能的使用，而且一直在持续更新迭代，值得点赞!',
  },
  {
    author: {
      name: '玩AI的小笼包',
      role: 'AIGC短片导演',
      avatar: 'https://image01-aliyun.vidu.zone/vidu/media-asset/xiaolongbao-b00337ff.webp',
    },
    text: '我一直用AI做影视广告，也拿Vidu跑过不少商业项目。它最打动我的不只是快，而是真的懂镜头、动作和表演，让过去只能写在剧本里的画面，真正被做出来。',
  },
  {
    author: {
      name: '柔数特效',
      role: '二次元动画导演',
      avatar: 'https://image01.vidu.zone/vidu/media-asset/userImageChina4-5a2c61f5.webp',
    },
    text: 'Vidu第一次帮我解决的问题是，二次元人物动态有很好的流畅性，这个是当时很多AI平台不能控制的，我之前一直是使用AE为二次元人物做动态，Vidu的出现让我在人物的编辑上节省了不少时间。',
  },
  {
    author: {
      name: '普方',
      role: 'AIGC导演·数字艺术家',
      avatar: 'https://image01-aliyun.vidu.zone/vidu/media-asset/pufanglogo-b54bce7d.webp',
    },
    text: '有幸较早参与测试，一路见证版本迭代更新，图生视频、画面稳定性持续进步。作为创作者，它给我的国风、和镜头表现等创作带来很大助力和拿了很多AI领域奖项，可以说对Vidu有着很深的感情。希望Vidu越来越好，做出最特别的模型。',
  },
  {
    author: {
      name: '杜坤',
      role: 'Vidu超级创作者、高校教师',
      avatar: 'https://image01-aliyun.vidu.zone/vidu/media-asset/dukun-c923915a.webp',
    },
    text: '推进AI漫剧项目创作时，Vidu始终是我的首选。其生成表现高度匹配项目创作预期，无论是角色主体稳定性、画面质感，还是产出效率，各项能力都可有力支撑创意高效落地。',
  },
  {
    author: {
      name: '吉川明静',
      role: '吉川AI工作室创始人',
      avatar: 'https://image01-aliyun.vidu.zone/vidu/media-asset/jichuan-60cc8587.webp',
    },
    text: 'Vidu在我心目中永远是做2D动画的神，我们的短片正是因为使用了Vidu的视频模型，才能够在去年的日本Short Anime动画大赛中获奖。也希望Vidu的模型能在今后将这一优势继续发扬光大，伴随我们一路前行。',
  },
  {
    author: {
      name: '森海荧光',
      role: 'AIGC导演',
      avatar: 'https://image01-aliyun.vidu.zone/vidu/media-asset/senhai-ddfd558c.webp',
    },
    text: '我是在制作一部动画短片的时候遇到的Vidu，他们首创的多参考生视频把我从图生视频的困境中解脱了出来，真正找到了做动画的乐趣，也看到了ai动画的未来，其出色的一致性和语义理解能力给整个创作过程带来了全新的体验。',
  },
];
